import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  readonly BaseUrl = environment.base_url;

  constructor() {
  }
  GetTokenExpiryDate() {
    return this.DateAdd(new Date(), environment.jwtTokenExpiry);
  }

  DateAdd(date: Date, days: number): Date {
    var newdate = new Date(date);
    newdate.setDate(newdate.getDate() + (days));
    return newdate;
  }
}
